<template>
    <div class="row text-left form--items">
        <div class="col-12" >
            <div class="row">
                <div class="item--form col-12">
                    <label for="cardNumber">
                        <small>Número do cartão</small>
                    </label>
                    <input
                        type="tel"
                        id="cardNumber"
                        class="form-control"
                        v-mask="'#### #### #### ####'"
                        v-model="userCardData.cardNumber"
                        @blur="findBrand(userCardData.cardNumber)"
                    />
                    <p class="errors" v-if="errors.cardNumber">{{errors.cardNumber}}</p>
                </div>
                <div class="item--form col-12">
                    <label for="cardName">
                        <small>Nome do Titular</small>
                    </label>
                    <input
                        type="text"
                        id="cardName"
                        v-model="userCardData.cardName"
                        @blur="checkValid(userCardData.cardName,3,'cardName','Nome do titular do cartão obrigatório')"
                        class="form-control"
                    />
                    <p class="errors" v-if="errors.cardName">{{errors.cardName}}</p>
                </div>
                <div class="w-100"></div>
                <div class="item--form col-6">
                    <label for="cardValidate">
                        <small>Validade do cartão</small>
                    </label>
                    <input
                        type="tel"
                        v-mask="'##/##'"
                        id="cardValidate"
                        v-model="userCardData.cardValidate"
                        @blur="checkDate(userCardData.cardValidate)"
                        class="form-control"
                    />
                    <p class="errors" v-if="errors.cardValidate">{{errors.cardValidate}}</p>
                </div>
                <div class="item--form col-6">
                    <label for="cardCode">
                        <small>CVV</small>
                    </label>
                    <input
                        type="tel"
                        v-mask="'###'"
                        id="cardCode"
                        v-model="userCardData.cardCode"
                        @blur="checkValid(userCardData.cardCode,3,'cardCode','Código de segurança do cartão obrigatório')"
                        class="form-control"
                    />
                    <p class="errors" v-if="errors.cardCode">{{errors.cardCode}}</p>
                </div>
            </div>
        </div>
</div>
</template>

<script>

export default {
    name: "CreditCard",
    data: () => {
        return {
            listErrors: [],
            planSelection: false,
            article: {
                title: "",
                description: "",
            },
            errors: {},
        }
    },
    props: {
        userCardData:{
            required: true,
            default : { 
                        userCardData: {
                            cardName: "",
                            cardNumber: "",
                            cardValidate: "",
                            cardCode: "",
                            cardBrand: "",
				        },
                    }
        },
    },
    methods:{
        checkValid(data,min = 3, nameError,text){
            if (!data || data.length < min) 
                this.$set(this.errors, nameError, text);
            else 
                this.$delete(this.errors, nameError);
        },
        checkDate(data){
            
            this.checkValid(this.userCardData.cardValidate,4,'cardValidate','Validade do cartão obrigatório')
            
            if(data){
                const monthCard = data.split('/')[0]
                const yearCard = data.split('/')[1]

                const currentDate = new Date();
                const currentMonth = currentDate.getMonth();
                const currentYear = currentDate.getFullYear().toString().substr(-2);

                if(yearCard >= currentYear) {
                    if( monthCard > 12 || monthCard == 0 ) {
                        this.$set(this.errors, 'cardValidate', 'Mês do cartão inválido');
                    }
                    else if(yearCard == currentYear && monthCard < currentMonth) {
                        this.$set(this.errors, 'cardValidate', 'Mês do cartão inválido');
                    }
                    else {
                        this.$delete(this.errors, 'cardValidate')
                    }
                }else {
                    this.$set(this.errors, 'cardValidate', 'Ano do cartão inválido');
                }
            }

        },
        checkError(){
            this.findBrand(this.userCardData.cardNumber)
            this.checkValid(this.userCardData.cardName,3,'cardName','Nome do titular do cartão obrigatório')
            this.checkDate(this.userCardData.cardValidate)
            this.checkValid(this.userCardData.cardCode,3,'cardCode','Código de segurança do cartão obrigatório')

            this.$emit('errorNumbers',Object.keys(this.errors).length)
        },
        findBrand(number) {
            this.checkValid(this.userCardData.cardNumber,1,'cardNumber','Número do cartão obrigatório')

            number = number.replace(/\s/g, "");
            // visa
            var re = new RegExp("^4");
            if (number.match(re) != null) this.userCardData.cardBrand = "Visa";
            // Mastercard
            // Updated for Mastercard 2017 BINs expansion
            if (
                /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
                    number
                )
            )
                this.userCardData.cardBrand = "Mastercard";
            // AMEX
            re = new RegExp("^3[47]");
            if (number.match(re) != null) this.userCardData.cardBrand = "AMEX";
            // Discover
            re = new RegExp(
                "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
            );
            if (number.match(re) != null) this.userCardData.cardBrand = "Discover";
            // Diners
            re = new RegExp("^36");
            if (number.match(re) != null) this.userCardData.cardBrand = "Diners";
            // Diners - Carte Blanche
            re = new RegExp("^30[0-5]");
            if (number.match(re) != null)
                this.userCardData.cardBrand = "Diners - Carte Blanche";
            // JCB
            re = new RegExp("^35(2[89]|[3-8][0-9])");
            if (number.match(re) != null) this.userCardData.cardBrand = "JCB";
            // Visa Electron
            re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
            if (number.match(re) != null) this.userCardData.cardBrand = "Visa Electron";
            // invalido

            this.checkValid(this.userCardData.cardBrand,1,'cardNumber','Número do cartão inválido')
	    }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/organisms/CheckoutStepCreditCard.vue